import { useMutation } from '@tanstack/react-query';
import { apiService } from '../services/api';
import type { AnalyticsDigestEntry } from '../types/analytics';

// STD-015: server state for the Website Analytics domain.
// apiService is imported here (a *.queries.ts file) per STD-016.
// The digest viewer is a demand-driven fetch (click-to-open), so it is
// modelled as a mutation (imperative action) rather than a background query.

export function useAnalyticsDigestMutation() {
  return useMutation<AnalyticsDigestEntry, Error, string>({
    // Failures are silent — the dialog stays open with no content, matching the
    // original console.error-only behaviour.
    meta: { skipGlobalErrorToast: true },
    mutationFn: (id: string) => apiService.getAnalyticsDigest(id),
  });
}
